import {DailyActivity2} from './dailyActivity2';

export const dailyActivity2 = {
   list: DailyActivity2
}